'use strict';

var base = require('../product/base');
var focusHelper = require('base/components/focus');
var location = window.location;
var tagmanager = require('int_googletagmanager/tagmanager');
var billingHelper = require('../razorpayButtons/billingHelper');
var dataLayer = window.dataLayer || [];
var $cartBtn = $('.cart-continue-btn');

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

$(document).ready(function () {
    var showCOD = $('#showCOD').val() === 'true';
    var showPanSuccess = $('.showPanSuccess').val() === 'true';
    if (showCOD) {
        $('#cod').prop('disabled', false).removeClass('disabled');
    } else {
        $('#cod').prop('checked', false).prop('disabled', true).addClass('disabled');
        $('#upi').prop('checked', true);
    }

    if (showPanSuccess) {
        $('.razorpaycheckout').prop('disabled', false);
    }
});

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
                + 'fade show" role="alert">'
                + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
                + '<span aria-hidden="true">&times;</span>'
                + '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> '
                + '<div class="col-12 text-center"> '
                + '<h1>' + data.resources.emptyCartMsg + '</h1> '
                + '</div> '
                + '</div>');
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    var currencySymbol = $('#currency-symbol').val();
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(currencySymbol + ' ' + data.totals.grandTotal);
    $('.sub-total').empty().append(currencySymbol + ' ' + data.totals.subTotal);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty()
            .append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);

        try {
            var rendered = (item.priceTotal && item.priceTotal.renderedPrice) ? item.priceTotal.renderedPrice : '';
            var cleaned = rendered.replace(/\bnull\b/g, '').trim();
            var priceText = $(cleaned).text().trim();
            var displayTotal = '<span class="currency-symbol">' + currencySymbol + '</span>'
                + '<span class="price-value"> ' + priceText + '</span>';
            $('.item-total-' + item.UUID).empty().append(displayTotal);
        } catch (e) {
            $('.item-total-' + item.UUID).empty().append(
                item.priceTotal && item.priceTotal.renderedPrice
                    ? item.priceTotal.renderedPrice.replace(/\bnull\b/g, '')
                    : ''
            );
        }
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error '
        + 'fade show" role="alert">'
        + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">'
        + '<span aria-hidden="true">&times;</span>'
        + '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i += 1) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">'
                    + lineItem.availability.inStockDate
                    + '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i += 1) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog quick-view-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 * @param {string} gtmData - gtmData
 * @param {string} currency - currency
 * @param {string} quantity - quantity
 */
function confirmDelete(actionUrl, productID, productName, uuid, gtmData, currency, quantity) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    var $moveToWishlistBtn = $('.add-product-modal-wishlist-btn');
    $moveToWishlistBtn.data('pid', productID);
    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);
    $deleteConfirmBtn.data('gtmdata', gtmData);
    $deleteConfirmBtn.data('currency', currency);
    $deleteConfirmBtn.data('quantity', quantity);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * Refreshes the coupon modal by making an AJAX GET request
 * and replacing the current coupon section with updated content from the server.
 */
function refreshCouponModal() {
    if ($('.cart-coupons-section').length > 0) {
        var targetUrl = $('.show-coupon-modal').data('target-url');
        if (!targetUrl) {
            return; // Exit if no target URL is available
        }

        $.spinner().start();
        $.ajax({
            url: targetUrl,
            method: 'GET',
            success: function (response) { // Extract the coupon modal content from the response
                var $responseHtml = $(response);
                var $newCouponModal = $responseHtml.find('.cart-coupons-section');

                if ($newCouponModal.length > 0) { // Replace the existing modal content with the fresh one
                    $('.cart-coupons-section').replaceWith($newCouponModal);
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.errorMessage) {
                    $('body').trigger('failureToast', err.responseJSON.errorMessage);
                } else {
                    // TODO: Handle other types of errors
                }
            }
        });
    }
}

/**
 * Updates the UI from cart to payment stage by:
 * - Changing button text and classes
 * - Hiding the product list
 * - Showing the payment section
 * - Updating progress indicators
 */
function cartToPaymentUpdates() {
    $('.cart-continue-btn').text('Pay Now');
    $('.cart-continue-btn').addClass('razorpaycheckout').removeClass('switch-to-payment-stage');
    $('.products-list-wrap').addClass('d-none');
    $('.address-detail-container').addClass('d-none');
    $('.estimated-delivery').addClass('d-none');
    $('.cart-payment-section').removeClass('d-none');
    $('.payment-options-heading-normal').removeClass('d-none');
    $('.cart-progress-bar').removeClass('active');
    $('.shipping-progress-bar').addClass('active');
    $('.cart-progress-m').addClass('d-none');
    $('.payment-progress-m').removeClass('d-none');
    $('.coupons-container-aval').addClass('d-none');
    var panEnabled = $('.showpan').val();
    if (panEnabled === 'true') {
        $('.razorpaycheckout').prop('disabled', true);
    }
}

/**
     * Updates the character count message for a textarea input.
     * Calculates how many characters are remaining and updates the UI.
     */
function updateCharCount() {
    const $textarea = $('.gift-message-input');
    const maxChars = $textarea.attr('maxlength');
    const $charCount = $('#charCount');

    let currentLength = $textarea.val() ? $textarea.val().length : 0;
    let remaining = maxChars - currentLength;
    $charCount.text(remaining);
}

/**
 * Updates the display of the PAN number input based on its type (password or text).
 *
 * When the input type is 'password', it hides the input text visually using a CSS class
 * and displays an equivalent number of asterisks in a separate element to mimic masking.
 * When the input type is 'text', it shows the actual input and clears the asterisk display.
 *
 * Elements involved:
 * - `#panNumber`: The input field for the PAN number.
 * - `#asteriskDisplay`: The element where asterisks are shown in password mode.
 *
 * CSS Class:
 * - `dots-hidden`: Used to visually hide input text (e.g., by setting color to transparent).
 *
 * Assumes jQuery is available.
 */
function updateAsteriskDisplay() {
    const $pinInput = $('#panNumber');
    const $asteriskDisplay = $('#asterisk-display');
    const isPassword = $pinInput.attr('type') === 'password';
    const inputValue = $pinInput.val();

    if (isPassword) {
        // In password mode, show asterisks
        //   $pinInput.css('color', 'transparent');
        $pinInput.addClass('dots-hidden');
        $asteriskDisplay.text('*'.repeat(inputValue.length));
    } else {
        // In text mode, show actual numbers
        $pinInput.removeClass('dots-hidden');
        $asteriskDisplay.text('');
    }
}

module.exports = function () {
    $('body').on('change', '.giftWrap', function () {
        var giftWrapChecked = $(this).prop('checked');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        $.ajax({
            url: url,
            type: 'get',
            data: { giftWrapChecked: giftWrapChecked, uuid: uuid },
            success: function (data) {
                if (data.success) {
                    var isGiftWrapChecked = data.giftWrapChecked === 'true';
                    if (isGiftWrapChecked) {
                        $('body').trigger('successToast', data.message);
                    } else {
                        $('body').trigger('failureToast', data.message);
                    }
                } else {
                    $(this).closest('.product-info').find('.giftWrap').prop('checked', false);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            }
        });
    });

    $('body').on('click', '.giftMessage', function () {
        var giftMessageChecked = $(this).prop('checked');
        var uuid = $(this).data('uuid');
        if (giftMessageChecked) {
            $('#giftMessageModal').data('uuid', uuid); // Store UUID in the modal itself as a data attribute so it's guaranteed to be product-specific
            $('#giftMessageModal .add-gift-message').data('uuid', uuid); // Also set it on the button as before
            $('#giftMessageModal .gift-message').val('');// Clear any existing message in the modal
            $('#giftMessageModal').data('checkbox-element', this); // Store reference to the checkbox element
            updateCharCount();
            $('.default-messages span').removeClass('active');
            $('#giftMessageModal').modal('show');
        } else {
            $.ajax({
                url: $(this).data('action'),
                type: 'get',
                data: { giftMessageChecked: giftMessageChecked, uuid: uuid },
                success: function (data) {
                    if (data.success) {
                        // console.log(data.message);
                        var productLineItem = $('.product-line-item:has(.product-info.uuid-' + uuid + ')');
                        productLineItem.find('.gift-message-section').addClass('d-none').removeClass('d-flex');
                        $('body').trigger('failureToast', 'Gift message removed');
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                }
            });
        }
    });

    $('body').on('click', '.default-messages span', function () {
        var message = $(this).text();
        $('.default-messages span').removeClass('active');
        $(this).addClass('active');
        $('.gift-message').val(message);
        updateCharCount();
    });

    $('body').on('click', '.add-gift-message', function () {
        var giftMessage = $('.gift-message').val();
        if (!giftMessage) {
            $('.gift-error-message').removeClass('d-none');
            $('.gift-error-message').parent().addClass('error-gift-message');
            return;
        }
        var url = $(this).data('action');
        var uuid = $('#giftMessageModal').data('uuid'); // Get the UUID from the modal itself, which we set when opening the modal
        $.ajax({
            url: url,
            type: 'get',
            data: { giftMessage: giftMessage, uuid: uuid },
            success: function (data) {
                if (data.success) {
                    var productLineItem = $('.product-line-item:has(.product-info.uuid-' + uuid + ')'); // Explicitly find the product line item with this UUID
                    if (productLineItem.length) {
                        productLineItem.find('.gift-message-section .display-gift-message').empty().append(data.giftMessage);
                        productLineItem.find('.gift-message-section').removeClass('d-none').addClass('d-flex');
                        $('#giftMessageModal').modal('hide');
                        $('body').trigger('successToast', 'Gift message added');
                    } else {
                        // Product line item not found for UUID 'uuid'
                    }
                } else {
                    $('.product-info.uuid-' + uuid).find('.giftMessage').prop('checked', false);
                }
            },
            error: function (data) {
                if (data.responseJSON && data.responseJSON.redirectUrl) {
                    window.location.href = data.responseJSON.redirectUrl;
                }
            }
        });
    });

    $('.gift-message-input').on('input', function () {
        updateCharCount();
    });

    $('.gift-message-input').on('blur', function () {
        $('.gift-error-message').toggleClass('d-none', $(this).val().length > 0);
    });

    $('body').ready(function () {
        updateCharCount();

        $('body').on('hidden.bs.modal', '#giftMessageModal', function () {
            var uuid = $(this).data('uuid');
            var checkbox = $(this).data('checkbox-element');
            var productLineItem = $('.product-line-item:has(.product-info.uuid-' + uuid + ')');
            var messageDisplayed = productLineItem.find('.gift-message-section').hasClass('d-flex');
            $('.gift-error-message').addClass('d-none');
            $('.gift-error-message').parent().removeClass('error-gift-message');

            if (!messageDisplayed && checkbox) { // If the message section is not displayed (message wasn't saved), uncheck the checkbox
                $(checkbox).prop('checked', false);
            }
        });
    });

    $('body').on('click', '.edit-gift-messsage', function () {
        var productLineItem = $(this).closest('.product-line-item');
        var uuid = productLineItem.find('.product-info').attr('class').split(' ') // Get the UUID from the product-info element within this product-line-item
            .find(function (className) {
                return className.startsWith('uuid-');
            })
            .replace('uuid-', '');
        var message = $(this).closest('.gift-message-section').find('.display-gift-message').text();
        $('#giftMessageModal').data('uuid', uuid); // Store the UUID on the modal
        $('#giftMessageModal .add-gift-message').data('uuid', uuid);
        $('.gift-message').val(message); // Set the existing message
        $('#giftMessageModal').modal('show');
    });

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        var gtmData = $(this).data('gtmdata');
        var currency = $(this).data('item-currency');
        var quantity = $(this).closest('.product-info').find('.quantity-form .quantity').val();
        confirmDelete(actionUrl, productID, productName, uuid, gtmData, currency, quantity);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('.optional-promo').click(function (e) {
        e.preventDefault();
        $('.promo-code-form').toggle();
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $('.remove-from-cart').val();
        var uuid = $(this).data('uuid');
        var gtmData = $(this).data('gtmdata');
        var currency = $(this).data('currency');
        var quantity = $(this).data('quantity');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };
        var $btn = $(this);
        var triggeredByWishlist = $btn.data('triggeredByWishlist') || false;

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                    if (!triggeredByWishlist) {
                        $('body').trigger('failureToast', 'Item Removed');
                    }
                    $btn.removeData('triggeredByWishlist');
                    tagmanager.removeFromCartEvent(gtmData, currency, quantity);
                    window.location.reload();
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i += 1) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                    if (!triggeredByWishlist) {
                        $('body').trigger('failureToast', 'Item Removed');
                    }
                    $btn.removeData('triggeredByWishlist');
                    tagmanager.removeFromCartEvent(gtmData, currency, quantity);
                    window.location.reload();
                }

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    /**
 * Updates the visibility of the PAN card input section and the PAN verification success message
 * based on the provided data object. Also enables or disables the Razorpay checkout button.
 *
 * @param {Object} data - The object containing PAN verification visibility flags.
 * @param {boolean} data.showPan - Whether the PAN card section should be shown based on cart value.
 * @param {boolean} data.showPanSuccess - Whether the PAN has been successfully verified.
 */
    function updatePanVisibility(data) {
        if (data.showPan) {
            if (data.showPanSuccess) {
                $('#panCardSection').addClass('d-none');
                $('#panCardSuccess').removeClass('d-none');
                $('.razorpaycheckout').removeClass('disabled');
            } else {
                $('#panCardSection').removeClass('d-none');
                $('#panCardSuccess').addClass('d-none');
                $('.razorpaycheckout').addClass('disabled');
            }
        } else {
            $('#panCardSection').addClass('d-none');
            $('#panCardSuccess').addClass('d-none');
        }
    }

    $('body').on('change', '.quantity-form .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                updateCartTotals(data);
                updatePanVisibility(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);
                // refreshCouponModal();
                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
                $('.showpan').val(data.showPan && !data.showPanSuccess);
                if (data.showPan && !data.showPanSuccess) {
                    $('.pan-number').val('').trigger('input').trigger('change')
                        .trigger('keyup')
                        .removeClass('is-invalid');
                    $('.invalid-feedback.panNumber-error').removeClass('d-block').addClass('d-none');
                    $('.pan-verify-section').removeClass('d-none');
                    $('.razorpaycheckout').prop('disabled', true);
                } else if (!$cartBtn.hasClass('switch-to-payment-stage')) {
                    $('.cart-continue-btn').removeClass('cash-on-delivery').addClass('razorpaycheckout');
                    $('.razorpaycheckout').prop('disabled', false);
                    $('.razorpaycheckout').removeClass('disabled');
                }
                $('.showPanSuccess').val(data.showPanSuccess);
                $('.showAadharSuccess').val(data.showAadharSuccess);
                $('#isAadharVerificationEnabled').val(data.isAadharVerificationEnabled);
                if (data.showCOD) {
                    if (data.isAadharVerificationEnabled && data.showAadharSuccess) {
                        $('.cod-success-div').removeClass('d-none');
                    }
                    $('#cod').prop('disabled', false).removeClass('disabled');
                } else {
                    $('#cod').prop('checked', false).prop('disabled', true).addClass('disabled');
                    $('.cod-success-div').addClass('d-none');
                    if (!$cartBtn.hasClass('switch-to-payment-stage')) {
                        $cartBtn.removeClass('cash-on-delivery');
                        $cartBtn.text($cartBtn.data('pay-now')).attr('data-action', '').addClass('razorpaycheckout');
                    }
                    $('#upi').prop('checked', true);
                }
                $('#showCOD').val(data.showCOD);
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.promo-code-btn', function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.promo-code-form .form-control').addClass('is-invalid');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            return false;
        }
        var $form = $('.promo-code-form');
        $('.promo-code-form .form-control').removeClass('is-invalid');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.promo-code-form .form-control').addClass('is-invalid');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $('body').trigger('promotion:error', data);
                    $('.coupon-code-field').focus();
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                    $('.modal').modal('hide');
                    $('body').trigger('successToast', 'Coupon code applied successfully');
                    $('.coupons-container-aval').addClass('d-none').removeClass('d-block');
                }
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var url = $('.delete-coupon-confirmation-btn').data('action');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
                $('body').trigger('failureToast', 'Coupon removed');
                $('.coupons-container-aval').addClass('d-block');
                refreshCouponModal();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr(
            'disabled',
            !$('.global-availability', dialog).data('ready-to-order')
            || !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);

        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('click', '.edit-delivery-address', function () {
        var editaddressurl = $(this).attr('data-edit-url');
        if (editaddressurl === 'null' || !editaddressurl) {
            editaddressurl = $('.data-edit-url').val();
        }
        $('body').spinner().start();
        $.ajax({
            url: editaddressurl,
            type: 'get',
            dataType: 'html',
            success: function (html) {
                if (html) {
                    $('#address-modal-wrapper').empty().append(html);
                    $('body').spinner().stop();
                    $('#addAddressModal').modal('show');
                    $('#addAddressModal').find('button.save-address-btn').removeClass('save-address-btn').addClass('checkout-address-btn');
                    $('#addAddressModal .py-floating-input').each(function () {
                        if ($(this).val().trim() !== '') {
                            $(this).addClass('has-value');
                        } else {
                            $(this).removeClass('has-value');
                        }
                    });
                }
            },
            error: function () {
                $('body').spinner().stop();
            }
        });
    });

    $('body').on('click', '.razorpaycheckout', function () {
        var callbackurl = $('.handlecallback').attr('data-url');
        var razorpayurl = $('.razorpayservicecall').attr('data-url');
        var razorpayredirecturl = $('.redirectCheckout').attr('data-url');
        var razorpaycancelurl = $('.cancelurl').attr('data-url');
        $.ajax({
            url: razorpayurl,
            method: 'POST',
            success: function (data) {
                if (data) {
                    $('.order-total-summary-section').empty().append(data.orderSummaryHtml);
                    $('.products-list-wrap').empty().append(data.productCardHtml);
                    setTimeout(function () {
                        var options = billingHelper.createRazorPayOptions(callbackurl, razorpaycancelurl, data, razorpayredirecturl);
                        //  eslint-disable-next-line no-undef
                        var rzp1 = new Razorpay(options);
                        rzp1.open();
                    }, 3000);// after 3 seconds razorpay modal will be shown
                }
            }
        });
    });

    $('body').on('click', '.change-address', function () {
        var url = $(this).data('action');
        var addressId = $(this).data('id');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.isAddressAvailable) {
                    $('#change-address-modal .modal-body').empty().append(data.renderedTemplate);
                    $('#change-address-modal').data('address-id', addressId);
                    $('#change-address-modal input[name="selectedShippingAddress"][value="' + addressId + '"]').prop('checked', true);
                    $('#change-address-modal').modal('show');
                }
            },
            error: function () {
            }
        });
    });

    $('body').on('change', 'input[name="selectedShippingAddress"]', function () {
        var $addressBlock = $(this).closest('.saved-addresses');
        var selectedAddressId = $(this).val();
        $('.change-address').attr('data-id', selectedAddressId);
        var newEditUrl = $addressBlock.find('.edit-url').val();
        $('.edit-delivery-address').attr('data-edit-url', newEditUrl);
    });

    $('body').on('click', '.switch-to-payment-stage', function () {
        var addressExists = $('.cart-continue-btn').data('address-exists');
        if (addressExists) {
            cartToPaymentUpdates();

            var url = new URL(window.location.href); // Change URL from cart=true to payment=true
            if (url.searchParams.has('cart')) {
                var cartUrl = url.toString();
                url.searchParams.delete('cart');
                url.searchParams.append('payment', 'true');
                var paymentUrl = url.toString();

                window.history.replaceState({ step: 'cart' }, '', cartUrl);
                window.history.pushState({ step: 'payment' }, '', paymentUrl);
                $('.razorpaycheckout').removeAttr('disabled');
                var showPanSuccess = $('.showPanSuccess').val();
                var showAadharSuccess = $('.showAadharSuccess').val();
                var showpan = $('.showpan').val();
                if (showpan === 'true') {
                    $('.pan-verify-section').removeClass('d-none');
                    $('.pan-number').val('').trigger('input').trigger('change')
                        .trigger('keyup')
                        .removeClass('is-invalid');
                    $('.invalid-feedback.panNumber-error').removeClass('d-block').addClass('d-none');
                    $('.razorpaycheckout').prop('disabled', true);
                }
                if (showPanSuccess === 'true') {
                    $('.razorpaycheckout').removeClass('disabled').removeAttr('disabled', false);
                }
                if (showAadharSuccess === 'true') {
                    $('#cod').closest('.cod-and-msg').find('.cod-success-div').addClass('d-none');
                }
            } else {
                url.searchParams.append('payment', 'true');
                window.history.pushState({ step: 'payment' }, '', url.toString());
            }
            if (!$(this).hasClass('cash-on-delivery') || !$(this).hasClass('.razorpaycheckout')) {
                window.location.reload();
            }
        } else {
            $('#addAddressModal').modal('show');
        }
    });
    let selectedAddressId = null;
    $('body').on('click', '.saved-addresses', function () {
        $.spinner().start();
        $('.saved-addresses').removeClass('selected');
        $('.user-saved-addresses .form-check-input').prop('checked', false);
        $(this).addClass('selected');
        var $addressId = $(this).attr('address-id');
        localStorage.setItem('selectedAddressId', $addressId);
        $(this).find('.form-check-input').prop('checked', true);
        var url = $(this).attr('data-url');
        var form = {
            addressId: $addressId
        };
        if (!url) {
            return;
        }

        $.ajax({
            url: url,
            method: 'POST',
            dataType: 'json',
            data: form,
            success: function (response) {
                $('#change-address-modal').modal('hide');
                $('.address-detail-container .selected-delivery-address').empty().append(response.html);
                response.data.items.forEach(item => {
                    const deliveryDate = item.deliveryDate;
                    const uuid = item.UUID;
                    const $container = $(`.expected-delivery-msg[data-uuid="${uuid}"]`);
                    if (deliveryDate && uuid) {
                        if ($container.length) {
                            $container.find('strong').text(deliveryDate);
                            if ($container.hasClass('d-none')) {
                                $container.removeClass('d-none');
                                $container.closest('.return-expected-delivery-container').removeClass('d-none');
                            }
                        }
                    } else {
                        $container.addClass('d-none');
                        $container.closest('.return-expected-delivery-container').addClass('d-none');
                    }
                });
                if (!response.isCodAvailable) {
                    $('.cart-continue-btn').prop('disabled', false);
                    $('#cod').prop('disabled', true);
                    if (!$cartBtn.hasClass('switch-to-payment-stage')) {
                        $cartBtn.removeClass('cash-on-delivery');
                        $('.cod-success-div').addClass('d-none');
                        $cartBtn.text($cartBtn.data('pay-now')).attr('data-action', '').addClass('razorpaycheckout');
                        $('#upi').prop('checked', true);
                    }
                } else {
                    $('#cod').prop('disabled', false);
                    var showAadharSuccess = $('.showAadharSuccess').val();
                    if (showAadharSuccess === 'true') {
                        $('.cod-success-div').removeClass('d-none');
                    }
                }
                $.spinner().stop();
            },
            error: function () {
                $('#change-address-modal').modal('hide');
                $.spinner().stop();
            }
        });
    });

    /**
 * Applies the previously selected address by retrieving its ID from localStorage.
 * to preserve the user's selection visually and functionally.
 */
    function applySelectedAddress() {
        // Try to restore previously selected address from localStorage
        selectedAddressId = localStorage.getItem('selectedAddressId');
        var $selected = null;

        if (selectedAddressId) {
            $selected = $('.saved-addresses[address-id="' + selectedAddressId + '"]');
        }

        if ((!$selected || $selected.length === 0)) {
            var $checked = $('.user-saved-addresses .form-check-input:checked');
            if ($checked && $checked.length) {
                $selected = $checked.closest('.saved-addresses');
            }
        }

        if ((!$selected || $selected.length === 0)) {
            $selected = $('.saved-addresses.default, .saved-addresses[data-default="true"]').first();
        }

        if ($selected && $selected.length) {
            // clear previous selections
            $('.saved-addresses').removeClass('selected');
            $('.user-saved-addresses .form-check-input').prop('checked', false);

            var resolvedId = $selected.attr('address-id');
            if (resolvedId) {
                localStorage.setItem('selectedAddressId', resolvedId);
            }

            $selected.addClass('selected');
            $selected.find('.form-check-input').prop('checked', true);
        } else {
            // nothing to select; remove stale stored id
            localStorage.removeItem('selectedAddressId');
        }
    }
    $('#change-address-modal').on('shown.bs.modal', applySelectedAddress);
    $(document).ready(applySelectedAddress);

    $(document).ready(function () {
        // togglePanCardSection();
        var url = new URL(window.location.href);
        var pathParts = url.pathname.split('/');
        var lastPathPart = pathParts[pathParts.length - 1];

        if (lastPathPart === 'Cart-Show' && !url.searchParams.has('cart') && !url.searchParams.has('payment')) { // Add cart=true parameter only if we're on the Cart-Show route
            url.searchParams.append('cart', 'true');
            window.history.replaceState({ step: 'cart' }, '', url.toString());
        }

        if (url.searchParams.has('payment') && url.searchParams.get('payment') === 'true') { // If payment=true param exists
            cartToPaymentUpdates();
        }

        $(window).on('popstate', function () { // Set up popstate handler for back button navigation
            var currentUrl = new URL(window.location.href);
            if (currentUrl.pathname.indexOf('Cart-Show') !== -1) { // If we're at Cart-Show and have neither cart nor payment params, add cart=true
                if (!currentUrl.searchParams.has('payment') && !currentUrl.searchParams.has('cart')) { // If neither cart nor payment params are present
                    currentUrl.searchParams.append('cart', 'true');
                    window.history.replaceState({ step: 'cart' }, '', currentUrl.toString());
                }

                if (currentUrl.searchParams.has('payment') && currentUrl.searchParams.get('payment') === 'true') { // Update UI based on current URL parameters
                    cartToPaymentUpdates();
                } else {
                    $('.cart-continue-btn').text('Continue');
                    $('.cart-continue-btn').removeClass('razorpaycheckout cash-on-delivery').addClass('switch-to-payment-stage');
                    $('.products-list-wrap').removeClass('d-none');
                    $('.switch-to-payment-stage').removeAttr('disabled').removeClass('disabled');
                    $('.address-detail-container').removeClass('d-none');
                    $('.estimated-delivery').removeClass('d-none');
                    $('.cart-payment-section').addClass('d-none');
                    $('.payment-options-heading-normal').addClass('d-none');
                    $('.cart-progress-bar').addClass('active');
                    $('.shipping-progress-bar').removeClass('active');
                    $('.cart-progress-m').removeClass('d-none');
                    $('.payment-progress-m').addClass('d-none');
                    $('.coupons-container-aval').removeClass('d-none');
                }
            }
        });
        const $toggleButton = $('.toggle-visibility');
        const $eyeOpen = $('.eye-open');
        const $eyeClosed = $('.eye-closed');

        // Update asterisk display on input change

        $('#panNumber').on('input', function () {
            // Update asterisks display
            updateAsteriskDisplay();
        });

        // Toggle visibility button click handler
        $toggleButton.on('click', function () {
            // Toggle input type between password and text
            const isPassword = $('#panNumber').attr('type') === 'password';
            $('#panNumber').attr('type', isPassword ? 'text' : 'password');

            // Toggle eye icons
            $eyeOpen.toggleClass('d-none');
            $eyeClosed.toggleClass('d-none');

            // Update display based on new visibility state
            updateAsteriskDisplay();
        });

        // refreshCouponModal();
    });

    $('body').on('input', '.panNumber', function () {
        $(this).val(function (_, val) {
            return val.toUpperCase();
        });
    });

    $('body').on('click', '.verify-pan', function (e) {
        e.preventDefault();
        var panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
        var panNumber = $('.panNumber').val();
        var validatePan = panRegex.test(panNumber);
        var url = $(this).data('action');
        if (validatePan) {
            $.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                data: { panNumber: panNumber },
                success: function (data) {
                    if (data.response.success) {
                        $('.pan-card-section').addClass('d-none');
                        $('.pan-card-sucess-message').removeClass('d-none');
                        $('.razorpaycheckout').removeAttr('disabled').removeClass('disabled');
                        $('.cart-continue-btn.switch-to-payment-stage').prop('disabled', false);
                        $('.showpan').val('true');
                        $('.showPanSuccess').val('true');
                    } else {
                        $('.panNumber-error').addClass('d-block');
                        $('input.panNumber').addClass('is-invalid');
                        $('.razorpaycheckout').prop('disabled', true);
                        $('.panNumber-service-response').addClass('d-none');
                    }
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        } else {
            $('.panNumber-service-response').addClass('d-none');
            $('.panNumber-error').addClass('d-block');
            $('input.panNumber').addClass('is-invalid');
        }
    });

    /**
 * Updates the cart UI and handles Aadhaar verification modal display.
 *
 * This function makes an AJAX POST request to update the cart totals and product list,
 * then replaces the relevant DOM sections with the new HTML returned from the server.
 * After updating the cart, it checks whether Aadhaar verification is enabled and
 * whether the success flag is set, then shows or hides the Aadhaar modal accordingly.
 *
 * @function updateCartAadhar
 */
    function updateCartAadhar() {
        let urlUpdate = $('#update-cart-total-url').val();
        $.ajax({
            url: urlUpdate,
            type: 'post',
            success: function (data) {
                if (data) {
                    $('.order-total-summary-section').empty().append(data.orderSummaryHtml);
                    $('.products-list-wrap').empty().append(data.productCardHtml);
                    var isAadharVerificationEnabled = $('#isAadharVerificationEnabled').val();
                    var showAadharSuccess = $('.showAadharSuccess').val();
                    if (!(isAadharVerificationEnabled === 'true')) {
                        // Aadhaar not required → enable COD immediately
                        $('.cash-on-delivery').removeClass('disabled').prop('disabled', false);
                    }

                    setTimeout(function () {
                        if (isAadharVerificationEnabled === 'true') {
                            if (isAadharVerificationEnabled && (showAadharSuccess === 'true')) {
                                $('#aadhar').modal('hide');
                            } else {
                                $('#aadhar').modal('show');
                            }
                        }
                    }, 2000); // after 2 seconds aadhar modal will be shown
                }
            }
        });
    }

    $('body').on('change', 'input[name="payment_method"]', function () {
        var addressExists = $('.cart-continue-btn').data('address-exists');
        if ($(this).val() === 'cod' && $(this).prop('checked')) {
            var url = $('.cash-on-delivery').val();
            $('.cart-continue-btn').removeClass('razorpaycheckout');
            $('.cart-continue-btn').addClass('cash-on-delivery').prop('disabled', true);
            $('.cart-continue-btn').text($('.cart-continue-btn').data('place-order'));
            $('.cart-continue-btn').attr('data-action', url);
            var isAadharVerificationEnabled = $('#isAadharVerificationEnabled').val();
            var showAadharSuccess = $('.showAadharSuccess').val();
            if (isAadharVerificationEnabled && ((showAadharSuccess === 'true') || (!$('.cod-success-div').hasClass('d-none')))) {
                updateCartAadhar();
                if (!addressExists) {
                    $('.cart-continue-btn.switch-to-payment-stage').removeClass('cash-on-delivery');
                    $('.cart-continue-btn.switch-to-payment-stage').removeClass('disabled').removeAttr('disabled', false);
                } else {
                    $('.cart-continue-btn.cash-on-delivery').removeClass('switch-to-payment-stage');
                    $('.cash-on-delivery').removeClass('disabled').removeAttr('disabled', false);
                }
            } else {
                updateCartAadhar();
            }
        } else {
            $cartBtn = $('.cart-continue-btn').removeClass('cash-on-delivery switch-to-payment-stage disabled razorpaycheckout');
            if (addressExists) {
                $cartBtn.addClass('razorpaycheckout');
            } else {
                $cartBtn.addClass('switch-to-payment-stage');
            }
            $cartBtn.text($cartBtn.data('pay-now')).attr('data-action', '');
            $cartBtn.removeAttr('disabled');
        }
    });

    $('body').on('click', '.cash-on-delivery', function (e) {
        e.preventDefault();
        var url = $(this).data('action');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            success: function (data) {
                if (data.success) {
                    var redirect = $('<form>')
                        .appendTo(document.body)
                        .attr({
                            method: 'POST',
                            action: data.continueUrl
                        });

                    $('<input>')
                        .appendTo(redirect)
                        .attr({
                            name: 'orderID',
                            value: data.orderID
                        });

                    $('<input>')
                        .appendTo(redirect)
                        .attr({
                            name: 'orderToken',
                            value: data.orderToken
                        });

                    redirect.submit();
                } else {
                    $('body').trigger('failureToast', data.errorMessage);
                }
            },
            error: function () {
            }
        });
    });

    $('body').on('input', '.aadharNumber', function () {
        var value = $(this).val().replace(/\D/g, '');
        var clearIcon = $(this).siblings('.py-cross-right');
        var maxLength = 12;
        if (value.length > maxLength) {
            value = value.substring(0, maxLength);
            $('.aadhar-error').addClass('d-none');
            $('input.aadharNumber').removeClass('is-invalid');
        }

        if (value.length > 0) {
            clearIcon.removeClass('d-none');
        } else {
            clearIcon.addClass('d-none');
        }

        const parts = [];
        for (let i = 0; i < value.length; i += 4) {
            parts.push(value.substring(i, i + 4));
        }
        value = parts.join(' - ');
        $(this).val(value);
    });

    $(document).ready(function () {
        $('input.aadharNumber').on('blur', function () {
            if ($(this).val().trim().length >= 12) {
                $('.aadhar-error').addClass('d-none');
                $(this).removeClass('is-invalid');
            }
        });

        $('.aadhar-checkbox').on('change', function () {
            if ($(this).prop('checked')) {
                $(this).next('label').removeClass('error-class');
            }
        });
    });

    $('body').on('hidden.bs.modal', '#aadhar', function () {
        $('.aadharNumber').removeClass('has-value is-invalid').val('');
        $('.aadhar-terms-message').removeClass('error-class');
        $('.aadhar-checkbox').prop('checked', false);
        $('.aadhar-error').addClass('d-none');

        $('.aadhar-otp-verification').addClass('d-none');
        $('.aadhar-verification-section').removeClass('d-none');
        $('.otp-verification-section').addClass('d-none');

        $('.otp-input').val('').removeClass('error');
        $('.otpfeilds').removeClass('error');
        $('.aadharSection').removeClass('d-none');
        $('.aadharSuccessMessage').addClass('d-none');
        $cartBtn.text($cartBtn.data('pay-now')).attr('data-action', '').addClass('razorpaycheckout').removeClass('cash-on-delivery');
        $('#upi').prop('checked', true);
        $('.razorpaycheckout').removeAttr('disabled').removeClass('disabled');
    });

    $('body').on('click', '.verify-aadhar', function () {
        var minLength = 12;
        var aadharNumber = $('.aadharNumber').val().replace(/ - /g, '');
        if (aadharNumber.length < minLength) {
            $('.aadhar-error').removeClass('d-none');
            $('input.aadharNumber').addClass('is-invalid');
        }
        var checkbox = $('.aadhar-checkbox');
        var messageSpan = checkbox.next('label');

        if (!checkbox.prop('checked')) {
            messageSpan.addClass('error-class');
            return;
        }
        var url = $(this).data('action');
        $.spinner().start();
        $('body .veil').addClass('veil-index');
        $.ajax({
            url: url,
            type: 'post',
            data: { aadharNumber: aadharNumber },
            success: function (data) {
                if (data.response.success) {
                    $.spinner().stop();
                    $('.aadharSection').addClass('d-none');
                    $('.aadharSuccessMessage .aadharVerificationSuccess').text(data.response.message);
                    $('.aadharSuccessMessage').removeClass('d-none');
                    $('.aadhar-otp-verification').removeClass('d-none');
                    $('.aadhar-verification-section').addClass('d-none');
                    $('.otp-verification-section').removeClass('d-none');
                } else {
                    $.spinner().stop();
                    $('.aadhar-error').removeClass('d-none').text(data.response.message);
                    $('input.aadharNumber').addClass('is-invalid');
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click', '.aadharotp-submit', function (e) {
        e.preventDefault();
        var aadharNumber = $('.aadharNumber').val().replace(/ - /g, '');
        var $form = $(this).parents('.otp-verification-section').find('#otp-form');
        var inputs = $form.find("input[type='tel']");
        var otp = '';
        inputs.each(function () {
            otp += $(this).val();
        });
        var allEmpty = Array.from(inputs).every(function (input) {
            return $(input).val() === '';
        });
        var partiallyFilled = Array.from(inputs).some(function (input) {
            return $(input).val() === '';
        }) && !allEmpty;

        if (allEmpty) {
            $form.find('.otp-input').addClass('error');
            $form.find('.otp-error').text($('.otp-empty-verification').val());
            $form.find('.otp-error').removeClass('d-none');
            $('.otp-error').closest('.otpfeilds').addClass('error');
            return;
        }
        if (partiallyFilled) {
            $form.find('.otp-input').addClass('error');
            $form.find('.otp-error').addClass('d-none');
            $form.find('.invalid-otp-error').removeClass('d-none');
            $('.otp-error').closest('.otpfeilds').addClass('error');
            return;
        }
        var url = $(this).data('verifyotpurl');
        $.spinner().start();
        $('body .veil').addClass('veil-index');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                otp: otp,
                aadharNumber: aadharNumber
            },
            success: function (response) {
                $.spinner().stop();

                if (response.response.success) {
                    $('#aadhar').modal('hide');
                    $('.cash-on-delivery').removeClass('disabled').prop('disabled', false);
                    $('.cod-success-div').removeClass('d-none').show();
                    $('.showAadharSuccess').val('true');
                    var addressExists = $('.cart-continue-btn').data('address-exists');
                    if (!addressExists) {
                        $('.cart-continue-btn.switch-to-payment-stage').removeClass('cash-on-delivery');
                    } else {
                        $('.cart-continue-btn.cash-on-delivery').removeClass('switch-to-payment-stage');
                    }
                } else {
                    $('.aadhar-otp-error').removeClass('d-none').text(response.response.message);
                    $('input.aadharNumber').addClass('is-invalid');
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('click', '.coupon-code-btn', function () {
        navigator.clipboard.writeText($(this).val());
        var couponCopyMsg = $(this).closest('.available-coupons-container').data('msg');
        $('body').trigger('successToast', couponCopyMsg);
    });

    $('body').on('click', '.coupon-apply-btn', function () {
        $('.coupon-code-field').focus();
        var code = $(this).data('code');
        $('.coupon-code-field').val(code);
        $('.promo-code-btn').trigger('click');
    });

    $('.back-page-btn').on('click', function () {
        window.history.back();
    });

    $('body').on('click', '.show-coupon-modal', function () {
        $('#cartCouponModal').modal('show');
    });

    if ($(window).width() <= 1024) {
        $('body').on('click', '.coupon-text', function () {
            $('.show-coupon-modal').trigger('click');
        });
    }

    $('body').on('input', '.coupon-code-field', function () {
        $(this).val($(this).val().replace(/^\s+|[^\x20-\x7E]|[^a-zA-Z0-9 ]+/g, ''));
        if ($(this).val().trim() !== '') {
            $(this).addClass('has-value');
        }
    });

    $('body').on('hidden.bs.modal', '#cartCouponModal', function () {
        refreshCouponModal();
    });

    $('body').on('click', '.show-coupon-modal', function () {
        dataLayer.push({ event: 'view_promotion' });
    });

    $('body').on('click', '.promo-code-btn', function () {
        var $promoCodeStatus = 'success';
        var promoCode = $('.coupon-code-field').val();
        setTimeout(() => {
            if ($('.apply-coupon-failed').length || $('.coupon-code-field').hasClass('is-invalid')) {
                $promoCodeStatus = 'failed';
            }
            var obj = {
                event: 'select_promotion',
                promoCode: promoCode,
                promoCodeStatus: $promoCodeStatus,
                applicationMethod: 'Manual'
            };
            dataLayer.push(obj);
        }, 2000);
    });

    $(document).ready(function () {
        var triggeredClickData = JSON.parse(localStorage.getItem('triggeredClick'));
        if (triggeredClickData && triggeredClickData.triggered) {
            var targetButton = $('#' + triggeredClickData.clickedClass);
            targetButton.trigger('click');
            localStorage.removeItem('triggeredClick');
        }

        var addToCartData = JSON.parse(localStorage.getItem('addToCartData'));
        if (addToCartData && addToCartData.product_id && addToCartData.trigger) {
            var obj = {
                event: 'addToCartThroughVT',
                product_id: addToCartData.product_id,
                product_name: addToCartData.product_name,
                lead_ID: addToCartData.lead_ID,
                user_name: addToCartData.user_name,
                user_phone: addToCartData.user_phone,
                event_date: addToCartData.event_date
            };
            dataLayer.push(obj);
            localStorage.removeItem('addToCartData');
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};
